import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

class User extends React.Component {
    handleClick = (event) => {
        this.props.history.push('/manage/customers/' + this.props.client.id);
    };

    render() {
        const { client, active, last } = this.props;
        return (
            <div
                className={
                    'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand ' +
                    (active ? 'active' : '')
                }
                onClick={this.handleClick}
            >
                <div
                    className={classNames(
                        'flex_full_row  align_center padding_bottom_9',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row '}>
                        <span className="barlow_medium c_dark_grey_blue uppercase">
                            {client.nombre}
                        </span>
                    </div>
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

User.propTypes = {
    history: PropTypes.object.isRequired,
};

User = withRouter(User);

export default User;



// WEBPACK FOOTER //
// ./src/components/complex/manage/customers/Client.js